<template>
  <div class="ms-container contracts-register">
    <div class="contracts-register-controls filters-bar">
      <contracts-register />
      <!-- <i-button
        @click="exportTable"
        type="success"
      >
        Экспорт таблицы
      </i-button> -->
    </div>
    <div class="contracts-register-container">
      <inline-loader :loading="loading" v-if="loading && !nodata" />
      <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
        Не удалось загрузить реестр договоров
      </div>
      <contracts-register-list
        v-else-if="projects.length"
        :projects="projects"
        @update-table="getData(true)"
      />
      <div class="ms-nodata ms-text" v-else>
        Проекты отсутствуют
      </div>
    </div>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import ContractsRegisterList from '@/components/contracts-register/contracts-register-list'
import ContractsRegister from '@/components/filters/contracts-register'
import { mainUrl } from '@/config/urls'
import { downloadFile } from '@/utils'
import { getContractsRegisterUrl } from '@/config/filters'

export default {
  components: {
    InlineLoader,
    ContractsRegisterList,
    ContractsRegister
  },
  data () {
    return {
      loading: false,
      nodata: false,
      projects: [],
      token: this.$store.state.auth.token
    }
  },
  watch: {
    '$store.state.filters.contractsRegister': {
      handler: function () {
        this.getData()
      },
      deep: true
    },
    '$store.state.filters.company': function () {
      this.getData()
    }
  },
  methods: {
    async getData (noloading) {
      try {
        if (!noloading) this.loading = true

        const url = getContractsRegisterUrl(
          `page/contract_register`,
          this.$store.state.filters
        )
        const data = await this.$store.dispatch('GET_REQUEST', { url })
        this.projects = data

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.nodata = true
      }
    },
    exportTable () {
      const baseUrl = getContractsRegisterUrl(
        `page/contract_register`,
        this.$store.state.filters
      )
      const url = `${mainUrl}/api/${baseUrl}&format=excel&access_token=${this.token}`
      downloadFile(url)
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less"></style>
